document.addEventListener( 'keydown', ( e ) => {
	// 37 is the keycode for arrow left
	if ( e.keyCode === 37 ) {
		// Check if a list item anchor is focused, if not, focus the first one
		const focusedAnchor = document.querySelector( 'li a:focus' );
		if ( focusedAnchor ) {
			const current = focusedAnchor.parentElement;
			const previousAnchor =
				current.previousElementSibling.querySelector( 'a' );
			if ( previousAnchor ) {
				previousAnchor.focus();
			}
		}
	} else if ( e.keyCode === 39 ) {
		// Check if a list item anchor is focused, if not, focus the first one
		const focusedAnchor = document.querySelector( 'li a:focus' );
		if ( focusedAnchor ) {
			const current = focusedAnchor.parentElement;
			const nextAnchor = current.nextElementSibling.querySelector( 'a' );
			if ( nextAnchor ) {
				nextAnchor.focus();
			}
		}
	}
} );

document.addEventListener( 'DOMContentLoaded', () => {
	// Focus styles for menus when using keyboard navigation

	// Properly update the ARIA states on focus (keyboard) and mouse over events
	const menus = document.querySelectorAll( '[role="menubar"]' );
	menus.forEach( ( menu ) => {
		menu.addEventListener( 'focus', () => {
			const popups = menu.querySelectorAll( '[aria-haspopup="true"]' );
			popups.forEach( ( popup ) => {
				popup.setAttribute( 'aria-expanded', 'true' );
			} );
		} );

		menu.addEventListener( 'mouseenter', () => {
			const popups = menu.querySelectorAll( '[aria-haspopup="true"]' );
			popups.forEach( ( popup ) => {
				popup.setAttribute( 'aria-expanded', 'true' );
			} );
		} );

		// Properly update the ARIA states on blur (keyboard) and mouse out events
		menu.addEventListener( 'blur', () => {
			const popups = menu.querySelectorAll( '[aria-haspopup="true"]' );
			popups.forEach( ( popup ) => {
				popup.setAttribute( 'aria-expanded', 'false' );
			} );
		} );

		menu.addEventListener( 'mouseleave', () => {
			const popups = menu.querySelectorAll( '[aria-haspopup="true"]' );
			popups.forEach( ( popup ) => {
				popup.setAttribute( 'aria-expanded', 'false' );
			} );
		} );
	} );
} );
